import lazyWithRetry from 'tools/lazyWithRetry';

const component = lazyWithRetry(() => import(
	/* webpackChunkName: "SupplierServiceDashboardPage" */
	'pages/supplier/SupplierServiceDashboardPage'));

export default [{ component, exact: true, path: '/supplier_dashboard' }];